import React, { FC, useRef, useState } from 'react';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import { setDeDataStore } from 'src/fetch/data/store';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxData: FC<Props> = ({ data }) => {
  // const dataSet = {};
  // const setData = data;
  // const totalCount = 1;
  // const bindStateData = setDeDataStore(state => state.bindData);
  // const optionSet: any = gridOption(setData, totalCount, bindStateData);
  const clickEvt = (e: any) => {};

  return (
    <div className="_step_e_tax_receipt_data">
      <div className="_content">
        <div className="_btn_div">
          <div className="_item">
            <DefaultButton
              text="원천징수 영수증 확인"
              clickEvent={e => clickEvt(e)}
              // icon="ri-download-2-line"
              type="type1"
              styleDef={{ height: '36px', fontSize: '13px', width: '200px', color: '#555' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeTaxData;
